import React from 'react';
import './ndoeUi.css';

/**
 * NdoeActionButton — bouton tactile unifié (min-height 44px).
 *
 * Props :
 *  - variant : 'primary' | 'secondary' | 'ink' | 'danger' | 'ghost' (défaut 'secondary')
 *  - size    : 'md' | 'sm' (défaut 'md')
 *  - block   : pleine largeur
 *  - icon    : node icône (à gauche du label)
 *  - iconOnly: bouton carré sans label (fournir aria-label)
 *  - as      : 'button' | 'a' (défaut 'button')
 *  - href    : si as='a'
 *  - loading : désactive + libellé inchangé (spinner à gérer par l'appelant si besoin)
 *  - children: label
 *  - ...rest : onClick, disabled, type, aria-label, etc.
 */
export default function NdoeActionButton({
  variant = 'secondary',
  size = 'md',
  block = false,
  icon = null,
  iconOnly = false,
  as = 'button',
  href,
  loading = false,
  disabled = false,
  className = '',
  children,
  ...rest
}) {
  const classes = [
    'ndoe-btn',
    `ndoe-btn--${variant}`,
    size === 'sm' ? 'ndoe-btn--sm' : '',
    block ? 'ndoe-btn--block' : '',
    iconOnly ? 'ndoe-btn--icon' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const content = (
    <>
      {icon}
      {!iconOnly && children ? <span>{children}</span> : null}
    </>
  );

  if (as === 'a') {
    return (
      <a className={classes} href={href} {...rest}>
        {content}
      </a>
    );
  }

  return (
    <button
      type={rest.type || 'button'}
      className={classes}
      disabled={disabled || loading}
      {...rest}
    >
      {content}
    </button>
  );
}
